import ExtendedStatisticApi from './ExtendedStatisticApi'
import getBasePath from '@util/path'
import ExtendedCarHealthApi from '@api/ExtendedCarHealthApi'
import ExtendedMembershipApi from '@api/ExtendedMembershipApi'

let basePath = getBasePath()

export function createStatisticAPIClient (): ExtendedStatisticApi {
  return new ExtendedStatisticApi({ basePath })
}

export function createCarHealthAPIClient (): ExtendedCarHealthApi {
  return new ExtendedCarHealthApi({ basePath })
}

export function createMemberhsipAPIClient (): ExtendedMembershipApi {
  return new ExtendedMembershipApi({ basePath })
}
